import { ReactElement } from "react";

interface IProps { 
	condition: boolean; 
	children: ReactElement;
	wrapperIfTrue: (child: ReactElement) => ReactElement;
	wrapperIfFalse: (child: ReactElement) => ReactElement;
}

const ConditionalWrapper = (props: IProps) => {
	return props.condition ? props.wrapperIfTrue(props.children) : props.wrapperIfFalse(props.children)
}

export default ConditionalWrapper;